export default "__VITE_ASSET__BFoB00WD__"